import React, { Component } from 'react';
import { cvEng } from '../services/_templateData';
import { Modal, Table4, Col, ColInput, ColBtn, Table, Column } from '../components/elemans/_elemans'


export default class Table2 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lst: [],
            openModal1: false,
            selectedIndex: -1
        }
    }

    keyDownHandler = (e) => {
        //let element = document.querySelector('td');
        debugger
        if (e.key === "Escape") {
            this.setState({ openModal1: false });
        }
        if (e.key === 'Enter' || e.key === 'ArrowRight') {

            let element = e.srcElement;

            var form = e.target.form;
            var index = Array.prototype.indexOf.call(form, element);
            if (index < form.elements.length-1)
                form.elements[index + 1].focus();
            e.preventDefault();


            ////let form = element.parents('form:eq(0)');
            ////let focusable = form.find('input,a,select,button,textarea').filter(':visible');
            ////let next = focusable.eq(focusable.index(this) + 1);
            //document.dispatchEvent(new KeyboardEvent('keydown', { 'key': 'Tab' }));
            //document.dispatchEvent(new KeyboardEvent('keydown', { 'key': 'Tab' }));
            //document.dispatchEvent(new KeyboardEvent('keydown', { 'key': 'Tab' }));
            //document.dispatchEvent(new KeyboardEvent('keydown', { 'key': 'Tab' }));


            //e.preventDefault();
        }
        if (e.key === 'ArrowLeft') {

            let element = e.srcElement;

            var form = e.target.form;
            var index = Array.prototype.indexOf.call(form, element);
            if (index > 0)
                form.elements[index - 1].focus();
            e.preventDefault();
        }
    }

    lastItemKeydown = (e) => {
        if (e.key === 'Enter' || e.key === 'Tab')
            this.setState({ lst: [...this.state.lst, {}] });
    }

    componentDidMount() {

        document.addEventListener("keydown", this.keyDownHandler);

        this.setState({ lst: cvEng.educations }
            , () => {


            });
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.keyDownHandler);
    }

    validate = (x) => x.class = (x.year < 2022) ? ('bg-danger') : ('bg-success');

    handleChange = (e, i, field) => {
        this.state.lst[i][field] = e.target.value;

        this.setState({ lst: this.state.lst });
    }

    render() {
        return (
            <>
                <div>
                    {/*<Table headers={["level", '', "university", 'city', 'field']} minCellWidth="100" >
                        {this.state.lst.map((x, i) => {
                            this.validate(x);
                            return (<tr id={'tr_' + i} key={i} className={`${x.class}`}  >
                                <Column title="level"><input value={x.level} onChange={e => this.handleChange(e, i, 'level')} className="form-control" /></Column>
                                <Column><button onClick={() => this.setState({ openModal1: true, selectedIndex: i })} type="button" className="btn btn-outline-primary w-100" >{x.year}</button></Column>
                                <Column title="university"><input type="text" value={x.university} onChange={e => this.handleChange(e, i, 'university')} className="form-control" /></Column>
                                <Column title='city'><input value={x.city} onChange={e => this.handleChange(e, i, 'city')} className="form-control" /> </Column>
                                <Column title='field'><input value={x.field}
                                    onChange={e => this.handleChange(e, i, 'field')}
                                    onKeyDown={e => { if (i == this.state.lst.length - 1) this.lastItemKeydown(e) }}
                                    className="form-control" /></Column>
                            </tr>);
                        })}
                    </Table>*/}

                    <Table dataSource={this.state.lst}
                        minCellWidth="100"
                        headers={["level", '', "university", 'city', 'field']}
                        columns={(x, i) => {
                            this.validate(x);
                            return <>
                                <Column title="level" className={`${x.class}`}><input value={x.level} onChange={e => this.handleChange(e, i, 'level')} className="form-control" /></Column>
                                <Column><button onClick={() => this.setState({ openModal1: true, selectedIndex: i })} type="button" className="btn btn-outline-primary w-100" >{x.year}</button></Column>
                                <Column title="university"><input type="text" value={x.university} onChange={e => this.handleChange(e, i, 'university')} className="form-control" /></Column>
                                <Column title='city'><input value={x.city} onChange={e => this.handleChange(e, i, 'city')} className="form-control" /> </Column>
                                <Column title='field'><input value={x.field}
                                    onChange={e => this.handleChange(e, i, 'field')}
                                    onKeyDown={e => { if (i == this.state.lst.length - 1) this.lastItemKeydown(e) }}
                                    className="form-control" /></Column>
                            </>
                        }}
                    />

                    <Table4 dataSource={this.state.lst} minCellWidth="100" >
                        <Col field='level' title="level_4" className="bg-danger" />
                        <ColBtn field='year' title='year_4' onClick={() => this.setState({ openModal1: true})} />
                        <ColInput field='university' title="university_4" onChange={(e, i) => this.handleChange(e, i, 'university')} />
                        <ColInput field='city' title='city_4' onChange={(e, i) => this.handleChange(e, i, 'city')} />
                        <ColInput field='field' title='field_4' onChange={(e, i) => this.handleChange(e, i, 'field')} onKeyDown={(e, i) => { if (i == this.state.lst.length - 1) this.lastItemKeydown(e) }} />
                    </Table4>

                </div>

                {this.state.openModal1 &&
                    <Modal ocClose={() => this.setState({ openModal1: false, selectedIndex: -1 })} >
                        {this.state.selectedIndex}

                    </Modal>}
            </>
        );
    }
}

